import React, { useEffect, useCallback } from "react";
import { Typography } from "@mui/material";
import { useField } from "formik";

import RpCurrencyField from "@/components/muiCustom/textField/RpCurrencyField";
import RRDDirectMailToolTips from "../RRDDirectMailToolTips";
import {
  calculateRRDStoreCopyCost,
  resolveRRDStoreCopyConfig,
} from "@/features/campaigns/direct-mail/rrd/utils/rrdStoreCopyConfigHelper";

const CurrencyField = RpCurrencyField as React.ElementType;

function RRDDirectStoreCopyCostInput({
  name,
  storeCopyToggleName,
  storeCopyQntName,
  storeCopyCPMAdmin,
  storeCopyConfig,
}) {
  const [storeCopyCostField, , storeCopyCostFieldHelper] = useField(name);
  const [storeCopyToggleField] = useField(storeCopyToggleName);
  const [storeCopyQntField] = useField(storeCopyQntName);
  const resolvedStoreCopyConfig =
    storeCopyConfig ||
    resolveRRDStoreCopyConfig({
      campaign: { storeCopyCpm: storeCopyCPMAdmin },
    });

  const calculateDistributionCost = useCallback(
    (storeCopyQnt) => {
      return calculateRRDStoreCopyCost({
        config: resolvedStoreCopyConfig,
        storeCopyQnt,
        storeCopy: storeCopyToggleField.value,
      });
    },
    [resolvedStoreCopyConfig, storeCopyToggleField.value]
  );

  useEffect(() => {
    const distributionCost = storeCopyQntField.value
      ? calculateDistributionCost(storeCopyQntField.value || 0)
      : 0;
    if (storeCopyCostField.value !== distributionCost) {
      storeCopyCostFieldHelper.setValue(distributionCost);
    }
  }, [
    calculateDistributionCost,
    storeCopyCostField.value,
    storeCopyCostFieldHelper,
    storeCopyQntField.value,
  ]);

  return (
    <>
      <Typography variant="body2" gutterBottom fontWeight={600}>
        Cost{" "}
        <RRDDirectMailToolTips
          customContent={`$${resolvedStoreCopyConfig?.cpm || 0} per increments of 1,000.`}
        />
      </Typography>
      <CurrencyField
        fullWidth
        size="small"
        value={storeCopyCostField.value}
        disabled={!storeCopyToggleField.value}
        readOnly
        placeholder="0.00"
        fixedDecimalScale={true}
        sx={{
          "& .MuiOutlinedInput-root": {
            opacity: 0.6,
            pointerEvents: "none",
          },
        }}
      />
    </>
  );
}

export default RRDDirectStoreCopyCostInput;
